import script from "./ThreeFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeFeatures.vue?vue&type=script&setup=true&lang=js"

import "./ThreeFeatures.vue?vue&type=style&index=0&id=9bb9f310&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bb9f310"]])

export default __exports__